import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import LogController from "../../controller/LogController";

let timer: any = null;

const RiderRejectModal = (oProps: {
  title: string;
  isVisible: { visible: boolean; msg: string };
  setVisible: any;
  onCancel: any;
  cancelComment: string;
  onConfirm: any;
  confirmColor?: string;
  confirmComment: string;
  isRetry: boolean;
}) => {
  const onCloseModal = () => {
    oProps.setVisible({
      visible: false,
      msg: "",
    });
  };

  const checkConfirm = () => {
    if (timer === null) {
      if (oProps.isRetry) {
        timer = setTimeout(() => {
          timer = null;
        }, 10000);
      }
      oProps.onConfirm();
      LogController.click({
        path: "RiderRejectModal retry Button",
        params: "바로고 재접수 클릭",
        params2: "",
      });
    }
  };

  useEffect(() => {
    if (oProps.isVisible && oProps.isRetry) {
      timer = setTimeout(() => {
        timer = null;
      }, 10000);
    } else {
      timer = null;
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      open={oProps.isVisible.visible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "rejectConfirmModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />

          <p className="titleFont">{oProps.title}</p>
          <p className="subTitle">{oProps.isVisible.msg}</p>

          <div className="bottomButtonWrap">
            <div
              className={`confirmButton ${timer !== null && "inactive"}`}
              style={{
                color: oProps.confirmColor ? oProps.confirmColor : "#4dd2ae",
                borderColor: oProps.confirmColor
                  ? oProps.confirmColor
                  : "#4dd2ae",
              }}
              onClick={checkConfirm}
            >
              {oProps.confirmComment}
            </div>
            <div className="cancelButton" onClick={oProps.onCancel}>
              {oProps.cancelComment}
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default RiderRejectModal;

const Style = styled.div`
  .modal {
    width: 100%;
    padding: 4% 10%;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  .titleFont {
    padding-top: 40px;
    font-size: 28px;
    line-height: 40px;
    font-weight: 500;
    color: #000000;
    text-align: center;
  }
  .subTitle {
    padding-top: 20px;
    padding-bottom: 40px;
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
    color: #a7a7a7;
    text-align: center;
  }
  .content {
    font-size: 20px;
    line-height: 32px;
    color: #a7a7a7;
    text-align: center;
    padding-bottom: 10px;
  }
  span {
    color: #ff616b;
    font-weight: 600;
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .confirmButton {
      flex: 1;
      padding: 16px 0;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #4dd2ae;
      background: #ffffff;
      border: 1px solid #4dd2ae;
    }
    .confirmButton.inactive {
      color: #ffffff;
      background: #b2b2b2;
      border: 1px solid #b2b2b2;
    }

    .cancelButton {
      flex: 1;
      padding: 16px 0;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #333333;
      background: #f7f7f7;
      border: 1px solid #a7a7a7;
    }
  }
`;
